<div class="card p-4">
  <div class="close d-flex flex-row-reverse">
    <button class="btn btn-close pt-1" (click)="onClick()"></button>
  </div>
  <div class="header">Filter</div>
  <div class="subheading">Bitte filtern Sie nach Ihren Suchkriterien</div>
  <div class="reset-filter">
    <button class="btn btn-link text-black" (click)="resetFilter()">
      Filter zurücksetzen
    </button>
  </div>
  <div class="active-filters mb-3">
    <mat-chip-set>
      <mat-chip
        *ngFor="let filter of activeFilters()"
        (removed)="removeFilter(filter)"
      >
        {{ filter.displayText }}
        <button matChipRemove>
          <i class="bi bi-x-circle-fill text-qundis-primary"></i>
        </button>
      </mat-chip>
    </mat-chip-set>
  </div>
  <form [formGroup]="filterParamsForm" class="density-settings-4">
    <div class="filter-param date">
      <div class="section-heading">
        <span>Datum</span>
      </div>
      <div class="form-fields">
        <mat-form-field class="me-3" appearance="fill">
          <input formControlName="startDate" matInput type="date" />
        </mat-form-field>
        <span>-</span>
        <mat-form-field class="ms-3" appearance="fill">
          <input formControlName="endDate" matInput type="date" />
        </mat-form-field>
      </div>
    </div>
    <div class="filter-param time">
      <div class="section-heading">
        <span>Uhrzeit</span>
      </div>
      <mat-form-field class="me-3" appearance="fill">
        <input formControlName="startTime" matInput type="time" />
      </mat-form-field>
      <span>-</span>
      <mat-form-field class="ms-3" appearance="fill">
        <input formControlName="endTime" matInput type="time" />
      </mat-form-field>
    </div>
    <div>
      <div class="filter-param duration pre-select">
        <div class="section-heading">
          <span>Stillstandsdauer</span>
        </div>
        <div class="options mb-3">
          <mat-chip-listbox
            aria-label="Fish selection"
            (change)="logSelection($event)"
          >
            <mat-chip-option
              *ngFor="let option of presetFilters()"
              [value]="option.value"
              >{{ option.name }}
            </mat-chip-option>
          </mat-chip-listbox>
        </div>
      </div>
    </div>

    <div class="filter-param duration custom-duration">
      <div class="section-heading">
        <span>Selbst definieren</span>
      </div>
      <mat-form-field class="me-3" appearance="fill">
        <input formControlName="minDuration" matInput type="time" />
      </mat-form-field>
      <span>-</span>
      <mat-form-field class="ms-3" appearance="fill">
        <input formControlName="maxDuration" matInput type="time" />
      </mat-form-field>
    </div>
  </form>
</div>
